import { render, staticRenderFns } from "./Register-campaign.vue?vue&type=template&id=5758dcd6&"
import script from "./Register-campaign.vue?vue&type=script&lang=js&"
export * from "./Register-campaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports